import React from 'react';
import styles from './EnterpriseCardsSection.module.css';
import { MdKeyboardArrowRight } from 'react-icons/md';
import { FaTerminal } from 'react-icons/fa';
import { isSmallScreen } from '../../../utils/screen';

interface EnterpriseCardsSectionProps {
    title: React.ReactNode;
    subtitle: React.ReactNode;
    cards: Array<{
        title: React.ReactNode;
        description: React.ReactNode;
    }>;
}

const EnterpriseCardsSection: React.FC<EnterpriseCardsSectionProps> = ({ title, subtitle, cards }) => {
    return (
        <section className={styles.section}>
            <div className={styles.container}>
                <div className={styles.header}>
                    <FaTerminal size={isSmallScreen() ? 44 : 54} />
                    <div className={styles.headerContent}>
                        <h2 className={styles.title}>{title}</h2>
                        <p className={styles.subtitle}>{subtitle}</p>
                    </div>
                </div>
                <div className={styles.cardsContainer}>
                    {cards.map((card, index) => (
                        <div key={index} className={styles.card}>
                            <h3 className={styles.cardTitle}>{card.title}</h3>
                            <p className={styles.cardDescription}>{card.description}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default EnterpriseCardsSection; 